import { IBannerResponse } from "@finbackoffice/clientbff-client";
import { DeviceType, Language, SiteContentScopes } from "@finbackoffice/enums";
import { useCallback, useContext, useEffect, useState } from "react";
import { ClientBFFContext, useRuntimeConfig } from "@finbackoffice/site-core";
import { useParams } from "next/navigation";

export const useBonusBanners = (withAllBonuseBanners = true) => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const { lang: locale } = useParams();
    const client = useContext(ClientBFFContext);
    const [allBonusBanners, setAllBonusBanners] = useState<IBannerResponse[]>([]);

    const getBanners = useCallback(
        async (scopes: SiteContentScopes[]): Promise<IBannerResponse[]> => {
            try {
                const response = await client.getBanners({
                    language: locale as Language,
                    tags: [DeviceType.Mobile, COMMON_SITE_CONFIGS.appName, ...scopes],
                    equal: false,
                });

                return response.items;
            } catch {
                return [];
            }
        },
        [client, locale, COMMON_SITE_CONFIGS.appName],
    );

    useEffect(() => {
        if (withAllBonuseBanners) {
            const loadBanners = async (scopes: SiteContentScopes[]) => {
                const banners = await getBanners(scopes);
                setAllBonusBanners(banners);
            };

            const scopes = [SiteContentScopes.Bonuses];

            void loadBanners(scopes);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { allBonusBanners, getBanners };
};
